import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';

import { CurrentAccountJurisdictionPage } from './pages/CurrentAccountJurisdictionPage';
import { CurrentAccountJurisdictionTransactionPage } from './pages/CurrentAccountJurisdictionTransactionPage';
import { CurrentAccountPage } from './pages/CurrentAccountPage';
import { CurrentAccountTransactionPage } from './pages/CurrentAccountTransactionPage';

export const CurrentAccountRouting = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <RouteAuth access={[Role.AccountReports, Role.CurrentAccountAdmin]}>
            <CurrentAccountPage />
          </RouteAuth>
        }
      />

      <Route
        path=":accountId/transactions"
        element={
          <RouteAuth access={[Role.AccountReports, Role.CurrentAccountAdmin]}>
            <CurrentAccountTransactionPage />
          </RouteAuth>
        }
      />

      <Route
        path="jurisdiction"
        element={
          <RouteAuth access={[Role.AccountReports, Role.CurrentAccountAdmin]}>
            <CurrentAccountJurisdictionPage />
          </RouteAuth>
        }
      />

      <Route
        path="jurisdiction/:accountId/transactions"
        element={
          <RouteAuth access={[Role.AccountReports, Role.CurrentAccountAdmin]}>
            <CurrentAccountJurisdictionTransactionPage />
          </RouteAuth>
        }
      />
    </Routes>
  );
};
